export default "__VITE_ASSET__5732096f__"